import { render, staticRenderFns } from "./ActionPremiumChat.vue?vue&type=template&id=398b716b&scoped=true"
import script from "./ActionPremiumChat.vue?vue&type=script&lang=js"
export * from "./ActionPremiumChat.vue?vue&type=script&lang=js"
import style0 from "./ActionPremiumChat.vue?vue&type=style&index=0&id=398b716b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b716b",
  null
  
)

export default component.exports